import { LocationDataGeocoded } from '../location';
import { PhoneNumber } from '../phone';
export enum NotificationTypeEnum {
  SMS = 'SMS',
  Email = 'Email',
  WhatsApp = 'WhatsApp',
}
export type NotificationType = `${NotificationTypeEnum}`;

export interface Customer {
  firstname?: string;
  lastname: string;
  email?: string;
  location?: LocationDataGeocoded;
  billingLocation?: LocationDataGeocoded;
  phoneNumber?: PhoneNumber;
  birthDate?: Date;
  notificationPreference?: NotificationType;
}
